import React from 'react';
import PropTypes from 'prop-types';

const Tabs = ({
	action,
	activeTab,
	classes = '',
	data,
	mode = 'default',
}) => {
	const getNotificationValue = notifications => {
		let notificationValue = notifications;
		if (!notifications || notifications === 'blank') {
			notificationValue = ' ';
		}
		if (notifications > 99) {
			notificationValue = '99+';
		}
		return notificationValue;
	};

	return (
		<div className={`${mode === 'header' ? 'tabs-header__container' : 'tabs__container'} ${classes}`}>
			{data.map((tab, index) => (
				<button
					// eslint-disable-next-line react/no-array-index-key
					key={index}
					type="button"
					className={`tab ${activeTab === index ? 'is-active' : ''}`}
					onClick={() => action(index)}
					disabled={tab.disabled || false}
					id={`testid-${tab.id}`}
				>
					{tab.label}
					{(tab?.notifications > 0 || tab?.notifications === 'blank') && (
						<span className="tabs__notification-badge">{getNotificationValue(tab.notifications)}</span>
					)}
				</button>
			))}
		</div>
	);
};

export default Tabs;

Tabs.propTypes = {
	mode: PropTypes.string,
	activeTab: PropTypes.number.isRequired,
	classes: PropTypes.string,
	data: PropTypes.arrayOf(PropTypes.shape({
		label: PropTypes.string.isRequired,
		notifications: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	})).isRequired,
	action: PropTypes.func.isRequired,
};
